import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const ViewModal = ({ show, handleClose, isEdit }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">Admin Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <h6 className='text-center d-none'><img src="https://media.istockphoto.com/id/1459824813/vector/health-care-medical-icon-design.jpg?s=612x612&w=0&k=20&c=oJfp94KWM1HJZcykISWWG1W99JiSpeki4gmjIqs44yI=" style={{ width: 100 }} alt="" /></h6>
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>First Name:</span>
                            <p>{isEdit?.first_name || '-'}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Last Name:</span>
                            <p>{isEdit?.last_name || '-'}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Email:</span>
                            <p>{isEdit?.email || '-'}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Phone No</span>
                            <p>{isEdit?.phone || '-'}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Status</span>
                            <p>{(isEdit?.status == 1 ? 'Active' : 'DeActive')  || '-'}</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Created At</span>
                            <p>
                                <span class="badge bg-info">
                                    {isEdit?.created_at || '-'}
                                </span>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Updated At</span>
                            <p>
                                <span class="badge bg-info">
                                    {isEdit?.updated_at || '-'}
                                </span>
                            </p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewModal;